
<div class="matrix-grid" :class="verticalAlignmentClass()">
  <template v-for="(element, index) in gridElements">
    <div :class="getColClass(element.sort_order)">
      <div>
        <div :data-index="index" :data-id="index">
          <component v-if="element.client_id" :key="element.client_id"
                     :is="componentType(element)"
                     :is-in-edit-mode="isInEditMode"
                     :content-element="element"
                     :entry="entry"
          ></component>
        </div>
      </div>
    </div>
  </template>
</div>
